<app-loader *ngIf="isLoading"></app-loader>
<div class="modify-model">
    <div class="payment-option">
        <p>Update Payment Date</p>
        <div class="custom-close">
            <img src="../../assets/images/new-close.svg" (click)="closeDialog()" alt="Close" />
        </div>
    </div>
    <div *ngIf="errorMessage" class="information-icon">
        <h4 class="fill-error">{{ errorMessage }}</h4>
    </div>
    <div class="modify-output date-filter">
        <form [formGroup]="paymentDateForm" (ngSubmit)="onSubmit()">
            <div class="date-outer">
                <label for="paymentDate">Select new payment date <span class="custom-star">*</span></label>
                <div class="custom-select2 custom-date-calender">
                    <div #focusTrap tabindex="0"></div>
                    <p-calendar id="paymentDate" #paymentDatePicker formControlName="paymentDate"
                        placeholder="Select Date" dateFormat="MM dd, yy" [minDate]="minDate" [maxDate]="maxDate"
                        [readonlyInput]="true" appendTo="body"
                        [style]="{width: '150px', 'font-size': '12px'}">
                    </p-calendar><img [calendarOpener]="paymentDatePicker"
                        src="assets/images/date-calender.png" alt="calender" />
                </div>
            </div>
            <div class="save-btn">
                <p-button type="submit" label="Update"></p-button>
            </div>
        </form>
    </div>
</div>
